(() => {
    "use strict";
    function t() {
        this.entries = [];
    }
    function e(t, e) {
        i(t);
        var o = (function (t, e) {
            i(t),
                (function (t) {
                    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                    if (0 === t.length) return [];
                    if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name) throw new TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.");
                })(e);
            var o = [];
            return (
                e.forEach(function (e) {
                    for (var i = 0; i < t.options.length; i++)
                        if (t.options[i].name.toLowerCase() === e.name.toLowerCase()) {
                            o[i] = e.value;
                            break;
                        }
                }),
                o
            );
        })(t, e);
        return (function (t, e) {
            return (
                i(t),
                (function (t) {
                    if (Array.isArray(t) && "object" == typeof t[0]) throw new Error(t + "is not a valid array of options.");
                })(e),
                t.variants.filter(function (t) {
                    return e.every(function (e, i) {
                        return t.options[i] === e;
                    });
                })[0] || null
            );
        })(t, o);
    }
    function i(t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.");
    }
    (t.prototype.add = function (t, e, i) {
        this.entries.push({ element: t, event: e, fn: i }), t.addEventListener(e, i);
    }),
        (t.prototype.removeAll = function () {
            this.entries = this.entries.filter(function (t) {
                return t.element.removeEventListener(t.event, t.fn), !1;
            });
        });
    var o = '[name="id"]',
        r = '[name^="options"]',
        n = '[name="quantity"]',
        s = '[name^="properties"]';
    function a(e, i, o) {
        (this.element = e),
            (this.product = (function (t) {
                if ("object" != typeof t) throw new TypeError(t + " is not an object.");
                if (void 0 === t.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                return t;
            })(i)),
            (o = o || {}),
            (this._listeners = new t()),
            this._listeners.add(this.element, "submit", this._onSubmit.bind(this, o)),
            (this.optionInputs = this._initInputs(r, o.onOptionChange)),
            (this.quantityInputs = this._initInputs(n, o.onQuantityChange)),
            (this.propertyInputs = this._initInputs(s, o.onPropertyChange));
    }
    (a.prototype.destroy = function () {
        this._listeners.removeAll();
    }),
        (a.prototype.options = function () {
            return (
                (t = this.optionInputs),
                (e = function (t) {
                    return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                }),
                t.reduce(function (t, i) {
                    return (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) && t.push(e({ name: i.name, value: i.value })), t;
                }, [])
            );
            var t, e;
        }),
        (a.prototype.variant = function () {
        
            return e(this.product, this.options());
        }),
        (a.prototype.properties = function () {
            var t,
                e,
                i =
                    ((t = this.propertyInputs),
                    (e = function (t) {
                        return /(?:^(properties\[))(.*?)(?:\])/.exec(t)[2];
                    }),
                    t.reduce(function (t, i) {
                        return (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) && (t[e(i.name)] = i.value), t;
                    }, {}));
            return 0 === Object.entries(i).length ? null : i;
        }),
        (a.prototype.quantity = function () {
            return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
        }),
        (a.prototype._setIdInputValue = function (t) {
            var e = this.element.querySelector(o);
            e || (((e = document.createElement("input")).type = "hidden"), (e.name = "id"), this.element.appendChild(e)), (e.value = t.toString());
        }),
        (a.prototype._onSubmit = function (t, e) {
            (e.dataset = this._getProductFormEventData()), e.dataset.variant && this._setIdInputValue(e.dataset.variant.id), t.onFormSubmit && t.onFormSubmit(e);
        }),
        (a.prototype._onFormEvent = function (t) {
            return void 0 === t
                ? Function.prototype
                : function (e) {
                      (e.dataset = this._getProductFormEventData()), t(e);
                  }.bind(this);
        }),
        (a.prototype._initInputs = function (t, e) {
            return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
                function (t) {
                    return this._listeners.add(t, "change", this._onFormEvent(e)), t;
                }.bind(this)
            );
        }),
        (a.prototype._getProductFormEventData = function () {
            return { options: this.options(), variant: this.variant(), properties: this.properties(), quantity: this.quantity() };
        });
    function c(t, e) {
        "string" == typeof t && (t = t.replace(".", ""));
        let i = "";
        const o = /\{\{\s*(\w+)\s*\}\}/,
            r = e || "${{amount}}";
        function n(t, e = 2, i = ",", o = ".") {
            if (isNaN(t) || null == t) return 0;
            const r = (t = (t / 100).toFixed(e)).split(".");
            return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`) + (r[1] ? o + r[1] : "");
        }
        switch (r.match(o)[1]) {
            case "amount":
                i = n(t, 2);
                break;
            case "amount_no_decimals":
                i = n(t, 0);
                break;
            case "amount_with_comma_separator":
                i = n(t, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                i = n(t, 0, ".", ",");
        }
        return r.replace(o, i);
    }
    const u = async (t, e) => {
            (e || window.dispatchEvent(new Event("dynamic-cart-open"))),
            t && (t.description && 200 !== t.status ? window.toast.error({ message: t.description, icon: !1 }) : ""),
            ((t, e, i = {}) => {
                const o = new CustomEvent(e, { detail: i });
                t.dispatchEvent(o);
            })(window, "ajax-cart", { cartSections: t.sections });
    };
    class p extends HTMLElement {
        constructor() {
            super(),

            this.moveElement(),
          
                (this.productImagesContainer = this.closest("[data-product-container]").querySelector("desktop-product-image")),
               
                (this.productImagesSwiper = this.productImagesContainer.querySelector("[data-images-swiper]")),
               
                (this.productImagesSlides = Array.from(this.productImagesSwiper.querySelectorAll(".swiper-slide"))),
                (this.priceWrapperElement = this.closest("[data-product-info]").querySelector(".price")),
                (this.priceElement = Array.from(this.priceWrapperElement.querySelectorAll("[data-price]"))),
                (this.comparePriceElement = Array.from(this.priceWrapperElement.querySelectorAll("[data-compare-at-price]"))),
                (this.productHandle = this.getAttribute("product-handle")),
                (this.productFormElement = this.querySelector("form")),
                (this.submitButton = this.querySelector("[data-submit-product]")),
                (this.selectId = this.querySelector('[name="id"]')),
                (this.swatchColors = Array.from(this.querySelectorAll(".swatches__swatch.is-color"))),
                (this.colorNames = this.querySelector(".color-names")),
                (this.displayColorName = this.displayColorNames.bind(this)),
                this.swatchColors.forEach((t) => {
                    t.addEventListener("mouseenter", this.displayColorName), t.addEventListener("mouseleave", this.displayColorName), t.addEventListener("click", this.displayColorName);
                }),
                (this.allSwatches = Array.from(this.querySelectorAll("[data-option-position]"))),
                // Store color-to-media mapping (built on initial load, used for all languages)
                (this.colorMediaMap = {}),
                // Store color translation map: translated color -> English color
                (this.colorTranslationMap = {}),
                this.initializeForm(),
              
                this.productFormElement.addEventListener("submit", this.submitProductForm.bind(this));
                
        }
        displayColorNames(t) {
            let e = t.currentTarget.querySelector("[data-swatch-colors]").innerHTML;
            if ("mouseleave" === t.type) {
                let t = Array.from(this.querySelectorAll('input[name="options[Color||Couleur]"]'));
                for (const i of t)
                    if (i.checked) {
                        e = i.previousElementSibling.innerHTML;
                        break;
                    }
            }
            this.colorNames.innerHTML = e?.toUpperCase();
        }
        async initializeForm() {
            // Validate productHandle before fetching
            if (!this.productHandle || this.productHandle === 'undefined' || typeof this.productHandle !== 'string' || this.productHandle.trim() === '') {
                // Try to get handle from URL as fallback
                const urlMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
                if (urlMatch && urlMatch[1]) {
                    this.productHandle = urlMatch[1];
                } else {
                    return; // Cannot proceed without product handle
                }
            }
            
            try {
                this.product = await this.getProductJson(this.productHandle);
                this.productForm = new a(this.productFormElement, this.product, { onOptionChange: this.optionsChange.bind(this) });
            } catch (error) {
                // Silently fail - product form will not initialize
                return;
            }
            (this.varientVideoSlider());
            this.setupSwatchListeners();
            
            // Build color-to-media mapping on initial load
            // This ensures same media shows for each color regardless of language
            this.buildColorMediaMap();
            
            // Initialize: Update images and size availability for initial color
            setTimeout(() => {
                const selectedOptions = this.getSelectedOptions();
                if (selectedOptions[0]) {
                    this.updateImagesForColor(selectedOptions[0]);
                    this.updateColorName(selectedOptions[0]);
                    this.updateSizeAvailabilityForColor([selectedOptions[0]]);
                } else {
                    // Get first variant's color
                    const firstVariant = this.product.variants[0];
                    if (firstVariant && firstVariant.options[0]) {
                        this.updateImagesForColor(firstVariant.options[0]);
                        this.updateColorName(firstVariant.options[0]);
                        this.updateSizeAvailabilityForColor([firstVariant.options[0]]);
                    }
                }
            }, 300);
        }
        
        setupSwatchListeners() {
            
            // Simple approach: Listen for all swatch clicks
            document.addEventListener('click', (e) => {
                // Check if clicked element is a swatch or inside a swatch
                const swatch = e.target.closest('.swatches__swatch');
                if (swatch) {
                    const input = swatch.querySelector('input[type="radio"]');
                    if (input) {
                        // Uncheck all other inputs in the same group
                        const allInputs = document.querySelectorAll(`input[name="${input.name}"]`);
                        allInputs.forEach(inp => inp.checked = false);
                        
                        // Check the clicked input
                        input.checked = true;
                        
                        // Update the UI
                        this.updateSwatchUI(input);
                    }
                }
            });
            
            // Also listen for size changes
            document.addEventListener('change', (e) => {
                if (e.target.type === 'radio' && e.target.dataset.optionPosition) {
                    this.updateSwatchUI(e.target);
                }
            });
            
            // Listen for main select changes
            const mainSelect = this.productFormElement.querySelector('select[name="id"]');
            if (mainSelect) {
                mainSelect.addEventListener('change', (e) => {
                    this.handleMainSelectChange(e.target.value);
                });
            }
            
            // Listen for language changes
            document.addEventListener('change', (e) => {
                if (e.target.classList.contains('localization-form__select') || 
                    e.target.classList.contains('localization-selector')) {
                    setTimeout(() => {
                        this.handleLanguageChange();
                    }, 1000);
                }
            });
            
            // Also listen for URL changes (when language changes via URL)
            window.addEventListener('popstate', () => {
                setTimeout(() => {
                    this.handleLanguageChange();
                }, 500);
            });
        }
        
        handleMainSelectChange(variantId) {
            const variant = this.product.variants.find(v => v.id == variantId);
            if (!variant) return;
            
            
            // Update all option inputs to match the selected variant
            variant.options.forEach((optionValue, index) => {
                const optionInputs = this.productFormElement.querySelectorAll(`input[data-option-position="${index + 1}"]`);
                optionInputs.forEach(input => {
                    if (input.value === optionValue) {
                        input.checked = true;
                    } else {
                        input.checked = false;
                    }
                });
            });
            
            // Update images based on the selected variant's color
            if (variant.options[0]) {
                this.updateImagesForColor(variant.options[0]);
                this.updateColorName(variant.options[0]);
            }
        }
        
        updateSwatchUI(input) {
            const optionPosition = input.dataset.optionPosition;
            const optionValue = input.value;
            
            
            // COLOR CHANGE: Update images/video and size availability
            if (optionPosition === '1') {
                
                // Step 1: Update images and video for this color (using alt text matching)
                this.updateImagesForColor(optionValue);
                
                // Step 2: Update color name display
                this.updateColorName(optionValue);
                
                // Step 3: Update size availability for THIS color
                // Build options array with the NEW color (no size selected yet)
                const optionsForThisColor = [optionValue];
                this.updateSizeAvailabilityForColor(optionsForThisColor);
                
            } else {
                // SIZE CHANGE: Just update button state
                const selectedOptions = this.getSelectedOptions();
                if (selectedOptions[0]) {
                    // Keep images for current color
                    this.updateImagesForColor(selectedOptions[0]);
                }
            }
            
            // Update main select and add to cart button
            this.updateMainSelectForCurrentOptions();
            const finalOptions = this.getSelectedOptions();
            const matchingVariant = this.findMatchingVariantForOptions(finalOptions);
            this.updateAddToCartButton(matchingVariant);
        }
        
        // NEW: Simple function to update size availability for a specific color
        updateSizeAvailabilityForColor(colorOptions) {
            
            if (!colorOptions[0]) {
                return;
            }
            
            // Get all size inputs (option position 2)
            const sizeInputs = this.productFormElement.querySelectorAll('input[data-option-position="2"]');
            
            sizeInputs.forEach(input => {
                const sizeValue = input.value;
                // Test: Color + This Size
                const testOptions = [colorOptions[0], sizeValue];
                
                // Find variant with this color + size combination
                const variant = this.product.variants.find(v => {
                    return v.options[0] === testOptions[0] && v.options[1] === testOptions[1];
                });
                
                if (variant && variant.available) {
                    // Available: Enable
                    input.classList.remove('swatches__disabled');
                    input.removeAttribute('data-unavailable');
                    input.closest('label')?.classList.remove('swatches__disabled');
                    input.closest('.swatches__swatch')?.classList.remove('swatches__disabled');
                } else {
                    // Unavailable: Disable (gray out)
                    input.classList.add('swatches__disabled');
                    input.setAttribute('data-unavailable', 'true');
                    input.closest('label')?.classList.add('swatches__disabled');
                    input.closest('.swatches__swatch')?.classList.add('swatches__disabled');
                }
            });
        }
        
        showSoldOutButton() {
            const addToCartButton = this.productFormElement.querySelector('button[type="submit"]');
            if (!addToCartButton) return;
            
            // Show sold out button
            addToCartButton.disabled = true;
            addToCartButton.classList.remove('available', 'hide');
            addToCartButton.classList.add('sold-out');
            
            // Set the text based on current language
            const currentLang = document.documentElement.lang || 'en';
            let buttonText = 'Sold out';
            
            if (currentLang === 'fr') {
                buttonText = 'Épuisé';
            } else if (currentLang === 'es') {
                buttonText = 'Agotado';
            } else if (currentLang === 'de') {
                buttonText = 'Ausverkauft';
            }
            
            addToCartButton.textContent = buttonText;
        }
        
        // Build color-to-media mapping on initial load (default language)
        // This ensures same media shows for each color regardless of language
        buildColorMediaMap() {
            this.colorMediaMap = {};
            
            // Get color option index
            const colorOption = this.product.options.find((opt, idx) => {
                const optLower = opt.toLowerCase();
                return optLower.includes('color') || optLower.includes('couleur') || idx === 0;
            });
            const colorOptionIndex = this.product.options.indexOf(colorOption);
            
            // CRITICAL: Get English color names from variant.options on INITIAL LOAD ONLY
            // Variant options are in default/English language on initial page load
            // This mapping is built once and NEVER rebuilt, so it always uses English color names
            const uniqueColors = new Set();
            this.product.variants.forEach(variant => {
                const color = variant.options[colorOptionIndex] || variant.options[0];
                if (color) {
                    uniqueColors.add(color);
                }
            });
            
            // Store unique colors array for cross-checking
            const uniqueColorsArray = Array.from(uniqueColors);
            
            // For each color, find all matching media
            uniqueColors.forEach(englishColor => {
                const colorLower = englishColor.toLowerCase().trim();
                const matchedMedia = [];
                
                // Find all variants with this color
                const variantsWithColor = this.product.variants.filter(v => {
                    const variantColor = v.options[colorOptionIndex] || v.options[0];
                    if (!variantColor) return false;
                    return variantColor.toLowerCase().trim() === colorLower;
                });
                
                // Match media for this color (STRICT matching to avoid cross-color matches)
                // Videos and images use the SAME matching logic - both match by English color name in alt text
                this.product.media.forEach((media, index) => {
                    let isMatch = false;
                    let mediaPosition = 1;
                    
                    // Method 1: Check if media is featured for any variant with this color
                    const isFeaturedForColor = variantsWithColor.some(variant => 
                        variant.featured_media && variant.featured_media.id === media.id
                    );
                    
                    // Method 2: Check alt text contains English color name (STRICT - word boundary matching)
                    // This works for BOTH images and videos - alt text always has English color name
                    const mediaAlt = (media.alt || '').toLowerCase().trim();
                    
                    // STRICT matching: Check if color name appears as a word in alt text
                    // Use word boundaries to avoid partial matches (e.g., "Grey" shouldn't match "Greyish")
                    const colorWordRegex = new RegExp(`\\b${colorLower.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
                    const colorInAlt = colorWordRegex.test(mediaAlt);
                    
                    // Also check if alt text starts with color name (e.g., "IVORY 1", "GREY_2", "IVORY" for video)
                    const altStartsWithColor = mediaAlt.startsWith(colorLower + ' ') || 
                                             mediaAlt.startsWith(colorLower + '_') ||
                                             mediaAlt.startsWith(colorLower + '-') ||
                                             mediaAlt === colorLower; // Exact match (common for videos)
                    
                    // Exact match
                    const exactMatch = mediaAlt === colorLower;
                    
                    // Only match if it's clearly for this color (not a substring match that could be another color)
                    if (isFeaturedForColor || colorInAlt || altStartsWithColor || exactMatch) {
                        // DOUBLE CHECK: Make sure this media doesn't belong to another color
                        // Check if alt text contains other color names (if so, it's ambiguous)
                        let belongsToOtherColor = false;
                        uniqueColorsArray.forEach(otherColor => {
                            if (otherColor.toLowerCase() !== colorLower) {
                                const otherColorLower = otherColor.toLowerCase().trim();
                                const otherColorRegex = new RegExp(`\\b${otherColorLower.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
                                if (otherColorRegex.test(mediaAlt) && otherColorLower.length >= colorLower.length) {
                                    // If alt text contains another color name that's longer or equal, it might belong to that color
                                    belongsToOtherColor = true;
                                }
                            }
                        });
                        
                        if (!belongsToOtherColor) {
                            isMatch = true;
                            
                            // Extract position from alt text (for images)
                            const altParts = (media.alt || '').split(/[\s_]+/);
                            for (const part of altParts) {
                                const partNum = parseInt(part);
                                if (partNum > 0 && partNum < 100) {
                                    mediaPosition = partNum;
                                    break;
                                }
                            }
                            
                            // Videos ALWAYS at position 2 (regardless of position number in alt text)
                            if (media.media_type === 'video') {
                                mediaPosition = 2;
                            }
                            
                            matchedMedia.push({
                                media: media,
                                position: mediaPosition,
                                index: index
                            });
                        }
                    }
                });
                
                // Store mapping for this color (using English color name as key)
                const englishColorKey = englishColor.toLowerCase().trim();
                this.colorMediaMap[englishColorKey] = matchedMedia;
                
                // Build translation map: Store all variant color names (including translated) -> English color
                // This allows us to find English color from translated color name
                variantsWithColor.forEach(variant => {
                    const variantColor = variant.options[colorOptionIndex] || variant.options[0];
                    if (variantColor) {
                        const variantColorKey = variantColor.toLowerCase().trim();
                        // Map translated color to English color
                        this.colorTranslationMap[variantColorKey] = englishColorKey;
                    }
                });
            });
        }
        
        // Rebuild translation map: translated color -> English color
        // This is called after language change to map new translated color names to English colors
        rebuildTranslationMap() {
            const colorOption = this.product.options.find((opt, idx) => {
                const optLower = opt.toLowerCase();
                return optLower.includes('color') || optLower.includes('couleur') || idx === 0;
            });
            const colorOptionIndex = this.product.options.indexOf(colorOption);
            
            // Clear existing translation map
            this.colorTranslationMap = {};
            
            // For each English color in the mapping, find all variants with that color
            Object.keys(this.colorMediaMap).forEach(englishColorKey => {
                const mappedMediaIds = this.colorMediaMap[englishColorKey].map(m => m.media.id);
                
                // Find ALL variants whose featured_media matches any media in this color's mapping
                this.product.variants.forEach(variant => {
                    const variantColor = variant.options[colorOptionIndex] || variant.options[0];
                    if (!variantColor) return;
                    
                    // Check if this variant's featured_media is in the mapping for this English color
                    const hasMatchingMedia = variant.featured_media && mappedMediaIds.includes(variant.featured_media.id);
                    
                    if (hasMatchingMedia) {
                        const variantColorKey = variantColor.toLowerCase().trim();
                        this.colorTranslationMap[variantColorKey] = englishColorKey;
                    }
                });
            });
        }
        
        updateImagesForColor(selectedColor) {
            // Get color option index
            const colorOption = this.product.options.find((opt, idx) => {
                const optLower = opt.toLowerCase();
                return optLower.includes('color') || optLower.includes('couleur') || idx === 0;
            });
            const colorOptionIndex = this.product.options.indexOf(colorOption);
            
            // Find ALL variants with this color (check all variants, not just available ones)
            const allVariantsWithColor = this.product.variants.filter(v => {
                const variantColor = v.options[colorOptionIndex] || v.options[0];
                if (!variantColor) return false;
                const variantColorLower = variantColor.toLowerCase().trim();
                const selectedColorLower = selectedColor.toLowerCase().trim();
                return variantColorLower === selectedColorLower || 
                       variantColorLower.includes(selectedColorLower) ||
                       selectedColorLower.includes(variantColorLower);
            });
            
            // CRITICAL: Get English color name from translation map (built on initial load)
            // This works even if variant.options are translated after language change
            const selectedColorKey = selectedColor.toLowerCase().trim();
            let englishColorKey = this.colorTranslationMap[selectedColorKey];
            
            if (!englishColorKey && allVariantsWithColor.length > 0) {
                // Fallback: Try to get from variant options
                const variantColor = allVariantsWithColor[0].options[colorOptionIndex] || allVariantsWithColor[0].options[0];
                const variantColorKey = variantColor.toLowerCase().trim();
                englishColorKey = this.colorTranslationMap[variantColorKey] || variantColorKey;
            }
            
            if (!englishColorKey) {
                englishColorKey = selectedColorKey;
            }
            
            // Use pre-built mapping (built on initial load, never rebuilt)
            if (Object.keys(this.colorMediaMap).length === 0) {
                this.buildColorMediaMap();
            }
            
            // Get media from mapping using English color key
            let matchedMedia = this.colorMediaMap[englishColorKey] || [];
            
            if (matchedMedia.length === 0) {
                return;
            }
            
            // ALWAYS hide all slides first
            const allSlides = document.querySelectorAll('[data-images-swiper] .swiper-slide');
            allSlides.forEach(slide => {
                slide.classList.add('hide');
                slide.classList.remove('selected');
            });
            
            // CRITICAL: Hide all videos using DOM query, NOT this.product.media
            // After language change, this.product.media has NEW IDs, but mapping has OLD IDs
            // So we find videos in DOM directly instead of using refreshed product.media
            const allVideoSlidesInDOM = document.querySelectorAll('[data-images-swiper] .swiper-slide[data-media-id]');
            allVideoSlidesInDOM.forEach(slide => {
                // Check if this slide contains a video element
                const hasVideoElement = slide.querySelector('video') !== null;
                if (hasVideoElement) {
                    slide.classList.add('hide');
                }
            });
            
            // Separate videos and images
            const videos = matchedMedia.filter(item => item.media.media_type === 'video');
            const images = matchedMedia.filter(item => item.media.media_type !== 'video');
            
            // Check if video exists (will ALWAYS be at position 2)
            const hasVideo = videos.length > 0;
            const video = videos[0];
            
            // Adjust image positions: if video exists, shift images with position >= 2 by +1
            const adjustedImages = images.map(item => {
                if (hasVideo && item.position >= 2) {
                    return {
                        ...item,
                        renderPosition: item.position + 1
                    };
                } else {
                    return {
                        ...item,
                        renderPosition: item.position
                    };
                }
            });
            
            // Sort images by render position
            adjustedImages.sort((a, b) => a.renderPosition - b.renderPosition);
            
            // Build final order: position 1 images, video at 2, then remaining images
            const finalOrder = [];
            
            // Step 1: Add all images with renderPosition = 1
            const position1Images = adjustedImages.filter(item => item.renderPosition === 1);
            finalOrder.push(...position1Images);
            
            // Step 2: Add video at position 2 (ALWAYS, if it exists)
            if (hasVideo && video) {
                const videoItem = {
                    media: video.media,
                    position: 2,
                    renderPosition: 2,
                    index: video.index
                };
                finalOrder.push(videoItem);
            }
            
            // Step 3: Add remaining images (renderPosition > 1)
            const remainingImages = adjustedImages.filter(item => item.renderPosition > 1);
            finalOrder.push(...remainingImages);
            
            // Final sort to ensure correct order
            finalOrder.sort((a, b) => {
                const posA = a.renderPosition || a.position || 999;
                const posB = b.renderPosition || b.position || 999;
                return posA - posB;
            });
            
            // Note: All slides (including videos) are already hidden at the start of this function
            // We don't need to hide videos again here - we'll show the correct ones from finalOrder
            
            if (finalOrder.length === 0) {
                const firstSlide = document.querySelector(`[data-images-swiper] .swiper-slide[data-media-id="${this.product.media[0]?.id}"]`);
                if (firstSlide) {
                    firstSlide.classList.remove('hide');
                    firstSlide.classList.add('selected');
                }
                return;
            }
            
            // Get the swiper wrapper
            const swiperWrapper = document.querySelector(`[data-images-swiper] .swiper-wrapper`);
            if (!swiperWrapper) {
                return;
            }
            
            // Collect all slides in the correct order
            const orderedSlides = [];
            
            // CRITICAL: Use the original media ID from the mapping (built on English/default language)
            // This ensures we find the correct slides even after language change when product.media IDs might change
            finalOrder.forEach((item, idx) => {
                // Use the media ID from the mapping (original ID from initial load)
                // This ID matches the data-media-id attribute in the DOM
                const mediaId = item.media.id;
                
                // Find slide by media ID (this ID is from the original mapping, matches DOM)
                const slide = document.querySelector(`[data-images-swiper] .swiper-slide[data-media-id="${mediaId}"]`);
                
                if (slide) {
                    // Show this slide
                    slide.classList.remove('hide');
                    const renderPos = item.renderPosition || item.position || (idx + 1);
                    slide.setAttribute('data-position', renderPos);
                    
                    // For videos, ensure they're visible and positioned correctly
                    // Videos matched in English should show on ALL languages
                    if (item.media.media_type === 'video') {
                        slide.setAttribute('data-video-slide', 'true');
                        slide.setAttribute('data-matched-video', 'true');
                        slide.setAttribute('data-position', '2');
                        slide.classList.remove('hide');
                        // Force video visibility - this ensures video shows on all languages
                        slide.style.display = '';
                    }
                    
                    // Select the first matching image/video
                    if (idx === 0) {
                        slide.classList.add('selected');
                    }
                    
                    orderedSlides.push({ slide, position: renderPos });
                }
            });
            
            // Reorder slides in DOM: Move video to position 2 (after position 1 images)
            const videoSlide = orderedSlides.find(({ slide }) => slide.hasAttribute('data-video-slide'));
            if (videoSlide) {
                const position1Slides = Array.from(swiperWrapper.querySelectorAll('.swiper-slide[data-position="1"]:not(.hide)'));
                if (position1Slides.length > 0) {
                    const lastPosition1Slide = position1Slides[position1Slides.length - 1];
                    const nextSibling = lastPosition1Slide.nextSibling;
                    if (nextSibling !== videoSlide.slide) {
                        swiperWrapper.insertBefore(videoSlide.slide, nextSibling);
                    }
                } else {
                    const firstVisibleSlide = swiperWrapper.querySelector('.swiper-slide:not(.hide)');
                    if (firstVisibleSlide && firstVisibleSlide !== videoSlide.slide) {
                        swiperWrapper.insertBefore(videoSlide.slide, firstVisibleSlide);
                    }
                }
            }
            
            // Update Swiper if it exists
            const swiperInstance = document.querySelector('[data-images-swiper]')?.swiper;
            if (swiperInstance) {
                swiperInstance.update();
            }
            
            // Ensure all non-matching videos are hidden
            // Use the original media IDs from the mapping, not the refreshed product.media
            const matchedVideoIds = finalOrder
                .filter(item => item.media.media_type === 'video')
                .map(item => item.media.id);
            
            // Get all video slides in DOM and hide those not in matchedVideoIds
            const allVideoSlides = document.querySelectorAll('[data-images-swiper] .swiper-slide[data-media-id]');
            allVideoSlides.forEach(slide => {
                const slideMediaId = slide.getAttribute('data-media-id');
                // Check if this is a video slide (by checking if it contains video element or has video class)
                const isVideoSlide = slide.querySelector('video') || slide.classList.contains('swiper-slide-video');
                
                if (isVideoSlide) {
                    // If this video is not in the matched list, hide it
                    if (!matchedVideoIds.includes(parseInt(slideMediaId))) {
                        slide.classList.add('hide');
                        slide.removeAttribute('data-matched-video');
                    }
                }
            });
            
            // CRITICAL: Ensure the matched video is visible (from English mapping)
            // This video should show on ALL languages, regardless of translated color name
            if (hasVideo && video) {
                const videoMediaId = video.media.id; // Original ID from English mapping
                const videoSlide = document.querySelector(`[data-images-swiper] .swiper-slide[data-media-id="${videoMediaId}"]`);
                if (videoSlide) {
                    videoSlide.classList.remove('hide');
                    videoSlide.setAttribute('data-matched-video', 'true');
                    videoSlide.setAttribute('data-position', '2');
                    // Force visibility
                    videoSlide.style.display = '';
                }
            }
            
            // Update dots for visible slides
            setTimeout(() => {
                this.updateDotsForVisibleSlides();
            }, 200);
        }
        
        // KEEP THIS for other uses, but simplified
        updateAllVariantOptions(providedOptions = null) {
            const selectedOptions = providedOptions || this.getSelectedOptions();
            if (!selectedOptions[0]) return;
            
            // If color is provided, update sizes for that color
            if (providedOptions && providedOptions[0]) {
                this.updateSizeAvailabilityForColor(providedOptions);
            }
        }
        
        // Force update all variant options on page load
        forceUpdateAllVariants() {
            
            // Get currently selected options to use as base
            const selectedOptions = this.getSelectedOptions();
            
            // Get all option inputs and update their availability
            const allOptionInputs = this.productFormElement.querySelectorAll('input[data-option-position]');
            
            // Group inputs by option position
            const inputsByPosition = {};
            allOptionInputs.forEach(input => {
                const position = parseInt(input.dataset.optionPosition);
                if (!inputsByPosition[position]) {
                    inputsByPosition[position] = [];
                }
                inputsByPosition[position].push(input);
            });
            
            
            // Process each option position
            Object.keys(inputsByPosition).forEach(position => {
                const inputs = inputsByPosition[position];
                
                inputs.forEach(input => {
                    const optionValue = input.value;
                    
                    // Create test options array based on current selection
                    const testOptions = [...selectedOptions];
                    testOptions[position - 1] = optionValue;
                    
                    // For size options (position 2), ensure we're using the currently selected color
                    if (position === 2) {
                    }
                    
                    // Use the new helper method to find matching variant
                    const matchingVariant = this.findMatchingVariantForOptions(testOptions);
                    
                    // Update availability - gray out unavailable variants but keep clickable
                    if (matchingVariant && matchingVariant.available) {
                        input.classList.remove('swatches__disabled');
                        input.disabled = false;
                        input.removeAttribute('data-unavailable');
                        const label = input.closest('label');
                        const swatch = input.closest('.swatches__swatch');
                        if (label) {
                            label.classList.remove('swatches__disabled');
                            label.removeAttribute('data-unavailable');
                        }
                        if (swatch) {
                            swatch.classList.remove('swatches__disabled');
                            swatch.removeAttribute('data-unavailable');
                        }
                    } else {
                        // Gray out unavailable variants but keep them clickable
                        input.classList.add('swatches__disabled');
                        input.disabled = false; // Keep clickable
                        input.setAttribute('data-unavailable', 'true');
                        const label = input.closest('label');
                        const swatch = input.closest('.swatches__swatch');
                        if (label) {
                            label.classList.add('swatches__disabled');
                            label.setAttribute('data-unavailable', 'true');
                        }
                        if (swatch) {
                            swatch.classList.add('swatches__disabled');
                            swatch.setAttribute('data-unavailable', 'true');
                        }
                    }
                });
            });
        }
        
        updateMainSelectOptions() {
            const selectElement = this.productFormElement.querySelector('select[name="id"]');
            if (!selectElement) return;
            
            const selectedOptions = this.getSelectedOptions();
            
            // Use the helper method to find matching variant
            const matchingVariant = this.findMatchingVariantForOptions(selectedOptions);
            
            if (matchingVariant) {
                selectElement.value = matchingVariant.id;
                selectElement.dispatchEvent(new Event("change"));
                
                // Update add to cart button state
                this.updateAddToCartButton(matchingVariant);
            }
        }
        
        updateSelectedOptionsFromVariant(variant) {
            // Update the radio inputs to match the variant
            variant.options.forEach((optionValue, index) => {
                const input = this.productFormElement.querySelector(`input[data-option-position="${index + 1}"][value="${optionValue}"]`);
                if (input) {
                    // Uncheck all inputs in this group
                    const allInputsInGroup = this.productFormElement.querySelectorAll(`input[data-option-position="${index + 1}"]`);
                    allInputsInGroup.forEach(inp => inp.checked = false);
                    
                    // Check the matching input
                    input.checked = true;
                }
            });
        }
        
        updateAddToCartButton(variant) {
            const addToCartButton = this.productFormElement.querySelector('button[type="submit"]');
            if (!addToCartButton) return;
            
            if (variant && variant.available) {
                // Variant is available - show "Add to Cart" button
                addToCartButton.disabled = false;
                addToCartButton.classList.remove('sold-out', 'hide');
                addToCartButton.classList.add('available');
                
                // Set the text based on current language
                const currentLang = document.documentElement.lang || 'en';
                let buttonText = 'Add to cart';
                
                if (currentLang === 'fr') {
                    buttonText = 'Ajouter au panier';
                } else if (currentLang === 'es') {
                    buttonText = 'Añadir al carrito';
                } else if (currentLang === 'de') {
                    buttonText = 'In den Warenkorb';
                }
                
                addToCartButton.textContent = buttonText;
            } else {
                // Variant is out of stock - show "Sold Out" button
                addToCartButton.disabled = true;
                addToCartButton.classList.remove('available', 'hide');
                addToCartButton.classList.add('sold-out');
                
                // Set the text based on current language
                const currentLang = document.documentElement.lang || 'en';
                let buttonText = 'Sold out';
                
                if (currentLang === 'fr') {
                    buttonText = 'Épuisé';
                } else if (currentLang === 'es') {
                    buttonText = 'Agotado';
                } else if (currentLang === 'de') {
                    buttonText = 'Ausverkauft';
                }
                
                addToCartButton.textContent = buttonText;
            }
        }
        
        handleLanguageChange() {
            // Wait for DOM to update after language change
            setTimeout(() => {
                
                // Re-fetch product data to get translated data
                this.refreshProductData();
                
                this.forceUpdateAllVariants();
                
                // CRITICAL: DO NOT rebuild mapping on language change
                // Use the original mapping built on default language (initial load)
                // This ensures same media shows for each color regardless of language
                
                // Rebuild translation map after language change (to map translated colors -> English colors)
                this.rebuildTranslationMap();
                
                // If mapping is empty (shouldn't happen), build it once
                if (Object.keys(this.colorMediaMap).length === 0) {
                    this.buildColorMediaMap();
                }
                
                // Get current selection
                const selectedOptions = this.getSelectedOptions();
                
                if (selectedOptions[0]) {
                    // Use mapping to show same media as default language
                    this.updateImagesForColor(selectedOptions[0]);
                    this.updateColorName(selectedOptions[0]);
                    // Also update size availability after language change
                    this.updateAllVariantOptions();
                    
                    // Force update dots after image update
                    setTimeout(() => {
                        this.updateDotsForVisibleSlides();
                    }, 300);
                }
                
                // Update add to cart button
                const matchingVariant = this.product.variants.find(variant => {
                    return variant.options.every((option, index) => {
                        return selectedOptions[index] === option;
                    });
                });
                if (matchingVariant) {
                    this.updateAddToCartButton(matchingVariant);
                }
            }, 500);
        }
        
        async refreshProductData() {
            // Only refresh if productHandle is available
            if (!this.productHandle) {
                return;
            }
            
            try {
                // Re-fetch product data to get translated version
                const newProductData = await this.getProductJson(this.productHandle);
                
                if (newProductData && newProductData.variants) {
                    this.product = newProductData;
                }
            } catch (error) {
                // Silently fail - keep existing product data
            }
        }
        
        fixInitialState() {
            // Get the currently selected options
            const selectedOptions = this.getSelectedOptions();
            
            // If no color is selected, try to get it from the main select or URL
            if (!selectedOptions[0]) {
                // Try to get the current variant from the main select
                const mainSelect = this.productFormElement.querySelector('select[name="id"]');
                if (mainSelect && mainSelect.value) {
                    const currentVariant = this.product.variants.find(v => v.id == mainSelect.value);
                    if (currentVariant) {
                        const colorValue = currentVariant.options[0];
                        
                        // Find and select the matching color input
                        const colorInput = this.productFormElement.querySelector(`input[data-option-position="1"][value="${colorValue}"]`);
                        if (colorInput) {
                            colorInput.checked = true;
                            selectedOptions[0] = colorValue;
                        } else {
                            const firstColorInput = this.productFormElement.querySelector('input[data-option-position="1"]');
                            if (firstColorInput) {
                                firstColorInput.checked = true;
                                selectedOptions[0] = firstColorInput.value;
                            }
                        }
                    } else {
                        const firstColorInput = this.productFormElement.querySelector('input[data-option-position="1"]');
                        if (firstColorInput) {
                            firstColorInput.checked = true;
                            selectedOptions[0] = firstColorInput.value;
                        }
                    }
                } else {
                    const firstColorInput = this.productFormElement.querySelector('input[data-option-position="1"]');
                    if (firstColorInput) {
                        firstColorInput.checked = true;
                        selectedOptions[0] = firstColorInput.value;
                    }
                }
            }
            
            // Update all variant options to set correct availability
            this.updateAllVariantOptions();
            
            // Update images for the current color
            if (selectedOptions[0]) {
                this.updateImagesForColor(selectedOptions[0]);
                this.updateColorName(selectedOptions[0]);
            }
            
            // Update add to cart button
            const matchingVariant = this.product.variants.find(variant => {
                return variant.options.every((option, index) => {
                    return selectedOptions[index] === option;
                });
            });
            if (matchingVariant) {
                this.updateAddToCartButton(matchingVariant);
            }
        }
        
        ensureFirstColorVariantSizes() {
            // Get the first color option
            const firstColorOption = this.product.options[0];
            if (!firstColorOption) return;
            
            // Get all variants for the first color
            const firstColorVariants = this.product.variants.filter(variant => 
                variant.options[0] === firstColorOption.values[0]
            );
            
            // Get all size options for the first color
            const firstColorSizes = firstColorVariants.map(variant => variant.options[1]).filter((size, index, self) => 
                self.indexOf(size) === index
            );
            
            // Ensure all size inputs for the first color are enabled
            firstColorSizes.forEach(size => {
                const sizeInput = this.productFormElement.querySelector(`input[data-option-position="2"][value="${size}"]`);
                if (sizeInput) {
                    sizeInput.classList.remove('swatches__disabled');
                    sizeInput.disabled = false;
                    const label = sizeInput.closest('label');
                    if (label) {
                        label.classList.remove('swatches__disabled');
                    }
                }
            });
        }
        
        
        getSelectedOptions() {
            const options = [];
            const inputs = this.productFormElement.querySelectorAll('input[type="radio"]:checked');
            
            inputs.forEach(input => {
                const position = parseInt(input.dataset.optionPosition);
                options[position - 1] = input.value;
            });
            
            return options;
        }
        
        
        findMatchingVariantForOptions(testOptions) {
            // Use Shopify native variant matching - exact match only
            const matchingVariant = this.product.variants.find(variant => {
                return variant.options.every((option, index) => {
                    return testOptions[index] === option;
                });
            });
            
            return matchingVariant || null;
        }
        
        updateMainSelectForCurrentOptions() {
            // Get all currently selected options
            const selectedOptions = this.getSelectedOptions();
            
            // Find the variant that matches all selected options
            const matchingVariant = this.findMatchingVariantForOptions(selectedOptions);
            
            if (matchingVariant) {
                // Update the main select dropdown
                const mainSelect = this.productFormElement.querySelector('select[name="id"]');
                if (mainSelect) {
                    mainSelect.value = matchingVariant.id;
                    mainSelect.dispatchEvent(new Event("change"));
                }
            }
        }
        
        updateMainSelectForColor(selectedColor) {
            // Use the helper method to find matching variant
            const matchingVariant = this.findMatchingVariantForColor(selectedColor);
            
            if (matchingVariant) {
                // Update the main select dropdown
                const mainSelect = this.productFormElement.querySelector('select[name="id"]');
                if (mainSelect) {
                    mainSelect.value = matchingVariant.id;
                    mainSelect.dispatchEvent(new Event("change"));
                }
            }
        }
        
        getProductJson(t) {
            // Validate product handle before fetching
            if (!t || t === 'undefined' || typeof t !== 'string' || t.trim() === '') {
                return Promise.reject(new Error('Product handle is required'));
            }
            
            // Use Shopify's native approach: get translated product data from the current page
            // This ensures we get the translated data, not the English API data
            
            // Try multiple sources for translated product data
            let productData = null;
            
            // Method 1: Check if product data is available in global scope (from Liquid)
            if (window._SIConfig?.product) {
                productData = window._SIConfig.product;
            }
            // Method 2: Check KiwiSizing data
            else if (window.KiwiSizing?.data) {
                productData = window.KiwiSizing.data;
            }
            // Method 3: Check Shopify analytics
            else if (window.Shopify?.analytics?.meta?.product) {
                productData = window.Shopify.analytics.meta.product;
            }
            
            if (productData) {
                // Ensure the product data has the expected structure
                if (productData.variants && productData.options) {
                    return Promise.resolve(productData);
                }
            }
            
            // Fallback to API if no translated data available
            return fetch(`/products/${t}.js`).then((response) => {
                if (!response.ok) {
                    throw new Error(`Failed to fetch product: ${response.status}`);
                }
                return response.json();
            }).catch((error) => {
                throw error;
            });
        }
        async submitProductForm(t) {
            t.preventDefault(),
                this.submitButton?.classList?.add("loading"),
                await (async (t) => {
                    window.dispatchEvent(new Event("dynamic-cart-loading"));
                  let path = window.Shopify.routes.root;
                    const e = await fetch(path + "cart/add.js", {
                        method: "POST",
                        body: ((i = t), Array.from(new FormData(i), (t) => t.map(encodeURIComponent).join("=")).join("&") + "&sections[]=cart-main&sections[]=dynamic-cart"),
                        headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    });
                    var i;
                    const o = await e.json();
                    u(o);
                })(this.productFormElement),
                this.submitButton?.classList?.remove("loading");
        }
        moveElement(){
          
         const moveElement =    setInterval(()=>{
            const singupForm  = document.getElementById("signUpForm")
                const element = document.getElementById("RnsignUpFormModal");
             
                if(singupForm){
                    clearInterval(moveElement)
                    document.body.appendChild(element)

                }
              
            

            },500)
           
        }
        optionsChange(t) {
            const e = t.dataset.variant;
            
            // Update browser history
            this.updateBrowserHistory(e);
            
            // Update main select dropdown
            this.updateMainSelect(e);
            
            // Update product price
            this.updateProductPrice(e);
            
            // Update out of stock options using our custom logic
            this.updateAllVariantOptions();
            
            // Update product button
            this.updateProductButton(e);
            
            // Update slide images
            this.updateSlideImages(e);
        }
        updateBrowserHistory(t) {
            if (!t) return;
            const e = (function (t, e) {
                return /variant=/.test(t) ? t.replace(/(variant=)[^&]+/, "$1" + e) : /\?/.test(t) ? t.concat("&variant=").concat(e) : t.concat("?variant=").concat(e);
            })(window.location.href, t.id);
            window.history.replaceState({ path: e }, "", e);
        }
        updateMainSelect(t) {
            t && ((this.selectId.value = t.id), this.selectId.dispatchEvent(new Event("change")));
        }
        istheSavedVariantAvailable(t) {
            var activeVariant = location.search.split('variant=')?.[1]
           
            let product =  this.product;
        let variantOp  =""

            if(!activeVariant){
                const element = document.getElementById("active-varient");
                 activeVariant =   element?.getAttribute("varient-id");
                
            }


           let activeVObj =  this.product?.variants?.filter((v)=>{
                return v.id==activeVariant
            })
           
            
           
            const varientVideoElement = document.getElementById(`${activeVariant}-preview-video`);
            
            const varientVideo =varientVideoElement?.getAttribute("data-src")
            const color =varientVideoElement?.getAttribute("color")

          

            const videoSource = document.getElementById("variant-preview-video");
            const imgSource = document.getElementById("variant-preview-image");


            if(varientVideo?.includes("videos")){
                var sources = videoSource.getElementsByTagName('source');
                 return !videoSource?.classList?.contains("hide") && sources[0].src == varientVideo;
            }else{
              
                return  !imgSource?.classList?.contains("hide") && imgSource.src == varientVideo;
            }
                
          
            return t.available;
        }
        varientVideoSlider(){
        
           
            var activeVariant = location.search.split('variant=')?.[1]
            
            if(!activeVariant){
                const element = document.getElementById("active-varient");
                 activeVariant =   element?.getAttribute("varient-id")
            }

            

           let activeVObj =  this.product?.variants?.filter((v)=>{
            return v.id==activeVariant
             })

             let option1 = activeVObj?.[0]?.option1;

            //  console.log("ededw" ,option1 )

            // console.log("element",`color=[${option1}]`,)
            let varientVideoElement = document.querySelectorAll(`div[color=${option1}]`)?.[0]
       
            // const varientVideoElement = document.getElementById(`${activeVariant}-preview-video`);
            //  console.log("wdqdw" ,varientVideoElement )
            const varientVideo =varientVideoElement?.getAttribute("data-src")
            const videoSource = document.getElementById("variant-preview-video");
            const imgSource = document.getElementById("variant-preview-image");

            const videoSlider = document.getElementById("variant-preview-slider");
            const slider = document.getElementById("variant-preview-video-dot");
            const swiperElements = document.querySelectorAll(".swiper-slide");
            // if(this.istheSavedVariantAvailable()){
                let isFound =  false;
           
                if(videoSource && imgSource && varientVideo){

                           
                     isFound =true
                    if(varientVideo?.includes("videos")){
                        const videosplit = varientVideo.split(".")
                        const extension = videosplit?.[videosplit.length-1]
                        imgSource?.classList?.add("hide")
                        videoSource?.classList?.remove("hide")
                        var sources = videoSource.getElementsByTagName('source');
                        sources[0].src =varientVideo;
                        sources[0].type = "video/"+extension;
                        videoSlider?.classList?.remove("hide")
                        
                        slider?.classList?.remove("hide")
                        videoSlider?.classList?.add("selected")
                        // slider?.classList?.add("selected")
                        
                        videoSource.load();
                        videoSource?.play();
                    }else{
                      
                        imgSource?.classList?.remove("hide")
                        videoSource?.classList?.add("hide")
                        imgSource.src = varientVideo;
                        videoSlider?.classList?.remove("hide")
                        slider?.classList?.remove("hide")
                        slider?.classList?.add("selected")
                        // videoSlider?.classList?.add("selected")
                       
                    }
    
                  
    
                    
                
                  
                }else{
                   
                  
                   
                   
                  if(slider && videoSlider ){
                        videoSlider?.classList?.add("hide")
                        videoSlider?.classList?.remove("selected")
                        slider?.classList?.add("hide")
                        slider?.classList?.remove("selected")
                    }

                    
               
                }
                let elemets = document.getElementById("product-dots");
                let slides = elemets.getElementsByClassName("swiper-slide")
              
                for (let i = 0; i < slides.length; i++) {
                    if(!slides[i].classList.contains("hide")){
                        if(!slides[i].classList.contains("selected")){
                            slides[i]?.classList?.add("selected")
                             isFound =true
                            break;
                        }else{
                            break;
                        }
                       
                    }
                  
                  }
            // }
         

           
           
            
           
            
        }
        removeAllDots(){
            let elemets = document.getElementById("product-dots");
            let slides = elemets.getElementsByClassName("swiper-slide")
            for (let i = 0; i < slides.length; i++) {
               
                  
                if(slides[i].classList.contains("selected")){
                    slides[i]?.classList?.remove("selected")
                 }
               
        
          
          }
        }
        updateProductPrice(t) {
            this.priceWrapperElement?.classList?.toggle("hide", !t),
                t &&
                    (this.priceElement.forEach((e) => (e.innerHTML = c(t.price, theme.moneyFormat)?.replace(".00", ""))),
                    this.comparePriceElement.forEach((e) => (e.innerHTML = c(t.compare_at_price, theme.moneyFormat)?.replace(".00", ""))),
                    t.compare_at_price > t.price ? this.priceWrapperElement?.classList?.add("price--on-sale") : this.priceWrapperElement?.classList?.remove("price--on-sale"),
                    t.available ? this.priceWrapperElement?.classList?.remove("price--sold-out") : this.priceWrapperElement?.classList?.add("price--sold-out"));
        }
        updateProductButton(t) {
            (this.submitButton.innerHTML = ""),
                t
                    ? t.available
                        ? ((this.submitButton.disabled = !1), (this.submitButton.innerHTML = theme.strings.product.addToCart), this.submitButton.classList.remove("hide"))
                        : ((this.submitButton.disabled = !0), (this.submitButton.innerHTML = theme.strings.product.soldOut), this.submitButton.classList.add("hide"))
                    : ((this.submitButton.disabled = !0), (this.submitButton.innerHTML = theme.strings.product.unavailable));
        }
        updateOutOfStockOptions(t) {
            const e = this.querySelector("input[id^=Option1]:checked"),
                i = this.querySelector("input[id^=Option2]:checked"),
                o = e ? e.value : null,
                r = i ? e.value : null;
            this.allSwatches.forEach((t) => {
                if (1 == t.dataset.optionPosition) var e = this.product.variants.find((e) => e.option1 === t.value && e.available);
                else if (2 == t.dataset.optionPosition) e = this.product.variants.find((e) => e.option1 === o && e.option2 === t.value && e.available);
                else if (3 == t.dataset.optionPosition) e = this.product.variants.find((e) => e.option1 === o && e.option2 === r && e.option3 === t.value && e.available);
                e ? t?.classList?.remove("swatches__disabled") : t?.classList?.add("swatches__disabled");
            });
        }
        updateSlideImages(t) {
            if (t) {
                // Find the actual variant object if t is just an ID
                let variant = t;
                if (typeof t === 'string' || typeof t === 'number') {
                    variant = this.product.variants.find(v => v.id == t);
                }
                
                if (variant) {
                    // Get the color option (first option)
                    const colorOption = this.product.options[0];
                    if (colorOption) {
                        const selectedColor = variant.options[colorOption.position - 1];
                        
                        // Use the dedicated method
                        this.updateImagesForColor(selectedColor);
                        this.updateColorName(selectedColor);
                    }
                }
            }
        }
        
        updateColorName(selectedColor) {
            const colorNameElement = document.querySelector('.color-names span');
            if (colorNameElement) {
                colorNameElement.textContent = selectedColor.toUpperCase();
            }
        }
        
        updateDotsForVisibleSlides() {
            // Wait a bit for DOM to update
            setTimeout(() => {
                const visibleSlides = document.querySelectorAll('[data-images-swiper] .swiper-slide:not(.hide)');
                const dotsContainer = document.querySelector('[data-image-dots]');
                
                if (dotsContainer) {
                    // Get all existing dots
                    const existingDots = dotsContainer.querySelectorAll('.swiper-slide');
                    
                    // Show/hide dots based on visible slides
                    existingDots.forEach(dot => {
                        const mediaId = dot.getAttribute('data-media-id');
                        const correspondingSlide = document.querySelector(`[data-images-swiper] .swiper-slide[data-media-id="${mediaId}"]`);
                        
                        if (correspondingSlide && !correspondingSlide.classList.contains('hide')) {
                            // Show the dot
                            dot.classList.remove('hide');
                            dot.style.display = '';
                        } else {
                            // Hide the dot
                            dot.classList.add('hide');
                            dot.style.display = 'none';
                        }
                    });
                    
                    // Update the dots container visibility
                    const visibleDots = dotsContainer.querySelectorAll('.swiper-slide:not(.hide)');
                    if (visibleDots.length > 1) {
                        dotsContainer.style.display = '';
                    } else {
                        dotsContainer.style.display = 'none';
                    }
                }
            }, 200);
        }
        
        removeAllDots() {
            const dotsContainer = document.getElementById("product-dots");
            if (dotsContainer) {
                dotsContainer.innerHTML = '';
            }
        }
    }
    
    try {
        customElements.define("product-form", p);
    } catch (t) {
        // Element already defined
    }
})();
